import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "attraversando_token";
const USER_TOKEN_KEY = "attraversando_user_token";
const USER_NAME_KEY = "attraversando_user_name";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const getUserToken = () => localStorage.getItem(USER_TOKEN_KEY);
export const setUserToken = (t, name) => {
  localStorage.setItem(USER_TOKEN_KEY, t);
  if (name) localStorage.setItem(USER_NAME_KEY, name);
};
export const clearUserToken = () => {
  localStorage.removeItem(USER_TOKEN_KEY);
  localStorage.removeItem(USER_NAME_KEY);
};
export const getUserName = () => localStorage.getItem(USER_NAME_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

// Separate axios instance for reader (logged-in user) endpoints.
export const userApi = axios.create({ baseURL: API });
userApi.interceptors.request.use((cfg) => {
  const t = getUserToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
userApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearUserToken();
      if (window.location.pathname.startsWith("/riservati")) {
        window.location.href = "/accedi";
      }
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (path) => (path ? `${BACKEND_URL}/api/files/${path}` : null);

// Lightweight anonymous page-view tracking. Fire-and-forget.
export const trackView = (path, postId = null) => {
  try {
    const body = JSON.stringify({ path, post_id: postId });
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(`${API}/track/view`, blob);
    } else {
      fetch(`${API}/track/view`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {}
};

// Update page <title> + <meta name="description"> + Open Graph for SEO and social sharing.
const SITE_NAME = "Attraversando";
const SITE_DESC = "Pensieri raccolti lungo la strada della notte, frammenti di letture, pause sotto un cielo basso, poesie, testi di canzoni. Pubblicati senza fretta, in silenzio, da solo.";

const _setMeta = (kind, key, value) => {
  if (!value) return;
  const sel = kind === "name" ? `meta[name="${key}"]` : `meta[property="${key}"]`;
  let el = document.querySelector(sel);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(kind === "name" ? "name" : "property", key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const setPageMeta = ({ title, description, image, url } = {}) => {
  const t = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  document.title = t;
  const d = description || SITE_DESC;
  _setMeta("name", "description", d);
  _setMeta("property", "og:title", t);
  _setMeta("property", "og:description", d);
  _setMeta("property", "og:type", title ? "article" : "website");
  if (url) _setMeta("property", "og:url", url);
  if (image) _setMeta("property", "og:image", image);
  _setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  _setMeta("name", "twitter:title", t);
  _setMeta("name", "twitter:description", d);
  if (image) _setMeta("name", "twitter:image", image);
};

// Resolves the cover image of a post, supporting both internal storage and
// external URLs (e.g. auto-assigned Lorem Picsum).
export const coverUrl = (post) => {
  if (!post) return null;
  if (post.cover_image_path) return `${BACKEND_URL}/api/files/${post.cover_image_path}`;
  if (post.cover_external_url) return post.cover_external_url;
  return null;
};
